import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TCommentDM from './TCommentDM'
import TPrTariffDateDM from './TPrTariffDateDM'

export default class TPrTariffDM extends Data {
	public static className = 'TPrTariffDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	StandardId?: number
	XmlField?: string
	ChangedOn?: Date
	CreatedOn?: Date
	TimeStamp?: string
	Description?: string
	IsBlockedRecord?: string
	RightGroupId?: number
	Name?: string
	Abbr?: string
	RID?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	LastCommentParamCalc?: string
	RightGroupIdCalc?: number
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM
	@Type(() => TCommentDM)
	CommentChild?: TCommentDM[]
	@Type(() => TPrTariffDateDM)
	PrTariffDateChild?: TPrTariffDateDM[]
}